<template>
  <div class="left-bar">
    <div class="left-bar-scroll">
      <div class="table_mine" :class="isActive?'active':''" @click="routerLink">
        <Icon type="speedometer" class="gray_icon"></Icon>
        <span>个人工作台</span>
      </div>

      <Menu
        @on-select="select"
        accordion
        ref="left_menu"
        :theme="theme"
        :active-name="currActiveName"
        :open-names="openName"
        :style="styleObject"
      >
        <Submenu
          v-for="(item, index) in childrenNar"
          :key="index"
          :name="item.name"
        >
          <template slot="title">
            <Icon :type="item.icon"></Icon>{{ item.text }}
          </template>
          <MenuItem
            v-if="item.children"
            v-for="(child, index) in item.children"
            :key="index"
            :name="child.name"
          >
            <router-link class="link-a" :to="child.url">{{
              child.text
            }}</router-link>
          </MenuItem>
        </Submenu>
      </Menu>
    </div>
  </div>
</template>

<script>
import { menulist } from "@/common/js/menu.js";
export default {
  // created() {
  //   this.reMenu = JSON.parse(sessionStorage.getItem('menu')); //根据后台返回显示左侧的列表;
  //   this.menulist = JSON.parse(JSON.stringify(menulist)); //固定的左侧列表
  //   this.init();
  // },
  data() {
    return {
      menulist: [],
      reMenu: [],
      styleObject: {
        width: "192px",
      },
      theme: "dark",
      childrenNar: "",
      openName: [],
      currActiveName: "",
      breadcrumb: [],
      isActive: false,
    }
  },
  methods: {
    select() {
      this.isActive = false
    },
    init() {
      this.isActive = false
      if(this.$route.path == '/homeMain/workbench/workbench'){
         this.isActive = true
         this.currActiveName = ''
      }
      
      if (!this.reMenu.length) {
        this.menulist.splice(0);
      }
      for (var i = 0; i < this.menulist.length; i++) {
        for (var j = 0; j < this.reMenu.length; j++) {
          if (this.menulist[i].id == this.reMenu[j].id) {
            this.menulist[i].text = this.reMenu[j].name;
            this.menulist[i].flag = true;
            for (var p = 0; p < this.menulist[i].children.length; p++) {
              for (var q = 0; q < this.reMenu[j].childList.length; q++) {
                if (
                  this.menulist[i].children[p].id ==
                  this.reMenu[j].childList[q].id
                ) {
                  this.menulist[i].children[p].text = this.reMenu[j].childList[
                    q
                  ].name;
                  this.menulist[i].children[p].flag = true;
                }
              }
            }
          }
        }
      }

      for (var i = 0; i < this.menulist.length; i++) {
        if (!this.menulist[i].flag) {
          this.menulist.splice(i, 1);
          i--;
        } else if (this.menulist[i].children.length) {
          let num = 0;
          for (var j = 0; j < this.menulist[i].children.length; j++) {
            if (!this.menulist[i].children[j].flag) {
              this.menulist[i].children.splice(j, 1);
              j--;
            } else {
              num++;
            }
          }
          if (!num) {
            this.menulist.splice(i, 1);
          }
        }
      }

      this.childrenNar = this.menulist; //根据后台返回显示左侧的列表
      let isBreak, fLeve, sLeve;
      this.menulist.forEach((v) => {
        if (v.children) {
          v.children.forEach((val) => {
            if (
              val.url == this.$route.path ||
              val.name == sessionStorage.getItem("currActiveName")
            ) {
              isBreak = true;
              this.currActiveName = val.name;
              sessionStorage.setItem("currActiveName", this.currActiveName);
              this.breadcrumb[0] = v.text;
              this.breadcrumb[1] = val.text;
              this.$emit("getbreadcrumb", this.breadcrumb);
            }
          });
          if (isBreak) {
            isBreak = false;
            this.openName = [];
            this.openName[0] = v.name;
            this.childrenNar = this.menulist;
            this.$nextTick(() => {
              this.$refs.left_menu.updateOpened();
              this.$refs.left_menu.updateActiveName();
            });
          }
        }
      });
    },
    routerLink() {
      (this.currActiveName = ""), sessionStorage.removeItem("currActiveName");
      this.openName = [""];
      this.breadcrumb = [];
      this.breadcrumb[0] = "欢迎页";
      this.$emit("getbreadcrumb", this.breadcrumb);
      this.$router.push("/homeMain/workbench/workbench");
    },
    openChange() {},
  },
  mounted() {
    this.reMenu = JSON.parse(sessionStorage.getItem("menu")); //根据后台返回显示左侧的列表;
    this.menulist = JSON.parse(JSON.stringify(menulist)); //固定的左侧列表
    this.isActive = true
    this.init();
  },
  watch: {
    $route(to, from) {      
      this.init();
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/left/index.vue